<template>
    <div class="setup-condition-content">
        <el-form ref="form" :model="conditionForm" label-width="90px" label-position="left">
            <el-form-item label="直播名称：">
                <el-input v-model="liveDetail.title" disabled style="width: 400px;"></el-input>
            </el-form-item>
            <el-form-item label="直播频道号：">
                <el-input v-model="liveDetail.id" disabled style="width: 400px;"></el-input>
            </el-form-item>
            <el-form-item label="观看条件：">
                <el-radio-group v-model="conditionForm.auth_type">
                    <el-radio label="white_list">白名单观看</el-radio>
                    <el-radio label="external">外部授权</el-radio>
                </el-radio-group>
                <div class="radio-tip" v-if="conditionForm.auth_type == 'white_list'">观看白名单：不区分大小写</div>
            </el-form-item>
            <div v-if="conditionForm.auth_type == 'white_list'" style="padding-left: 90px;">
                <div class="clearfix">
                    <div class="float-left">
                        <el-input v-model="queryParams.user_id" placeholder="输入用户账号" size="medium" style="width: 220px;" @keypress.native.enter="search"></el-input>
                        <el-input v-model="queryParams.username" placeholder="输入用户姓名" size="medium" style="width: 220px;" @keypress.native.enter="search" class="mg-left8"></el-input>
                        <el-button type="primary" size="medium" class="mg-left8" @click="search">搜索</el-button>
                    </div>
                    <div class="float-right">
                        <el-dropdown size="medium" split-button type="primary" @click="openUser()" @command="handleCommand" trigger="click">
                            新增数据
                            <el-dropdown-menu slot="dropdown">
                                <el-dropdown-item command="import">批量导入</el-dropdown-item>
                                <el-dropdown-item command="download">下载导入模板</el-dropdown-item>
                                <el-dropdown-item command="export">导出白名单</el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                    </div>
                </div>
                <!-- <div class="mg-top24">
                    <el-form-item label="白名单输入提示：" label-width="116px">
                        <el-input v-model="conditionForm.whitelist_input_tips" style="width: 400px;"></el-input>
                    </el-form-item>
                    <el-form-item label="白名单入口文案：" label-width="116px">
                        <el-input v-model="conditionForm.whitelist_entry_text" style="width: 400px;"></el-input>
                    </el-form-item>
                </div> -->
                <div class="mg-top16">
                    <el-table :data="tableData" border v-loading="listLoading">
                        <el-table-column prop="user_id" label="用户账号" min-width="160"></el-table-column>
                        <el-table-column prop="username" label="姓名" min-width="160"></el-table-column>
                        <el-table-column label="操作" width="180">
                            <template slot-scope="scope">
                                <el-button type="text" size="medium" @click="openUser(scope.row)">编辑</el-button>
                                <el-button type="text" size="medium" class="danger" @click="delUser(scope.row)">删除</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
                <div class="page-container text-align-right">
                    <Pagination v-bind:child-msg="pageParams" @pageChange="pageChange" />
                </div>
            </div>
            <div v-if="conditionForm.auth_type == 'external'" style="padding-left: 90px;">
                <el-form-item label="SECRET KEY：" label-width="115px" required>
                    <el-input v-model="conditionForm.external_key" style="width: 400px;"></el-input>
                </el-form-item>
                <el-form-item label="自定义URL：" label-width="115px" required>
                    <el-input v-model="conditionForm.external_uri" style="width: 400px;"></el-input>
                </el-form-item>
                <el-form-item label="授权失败地址：" label-width="115px">
                    <el-input v-model="conditionForm.external_redirect_uri" style="width: 400px;"></el-input>
                    <div class="radio-tip mg-top8">观众直接访问观看页时，跳转地址为空时，则显示默认提示页。设置跳转地址后，则跳转到所设置的地址</div>
                </el-form-item>
            </div>
            <el-form-item >
                <el-button type="primary" :loading="bLoading" @click="preserve">保 存</el-button>
            </el-form-item>
        </el-form>
        <div v-if="userDialog">
            <el-dialog :title="dialogTitle" :visible.sync="userDialog" width="580px">
                <div class="userForm-content">
                    <el-form :model="userForm" :rules="userRule" ref="userForm" label-width="88px" label-position="left">
                        <el-form-item label="用户账号：" prop="user_id">
                            <el-input v-model="userForm.user_id" placeholder="请输入用户账号"></el-input>
                        </el-form-item>
                        <el-form-item label="姓名：" prop="username">
                            <el-input v-model="userForm.username" placeholder="请输入姓名"></el-input>
                        </el-form-item>
                    </el-form>
                </div>
                <span slot="footer" class="dialog-footer">
                    <el-button size="small" @click="userDialog = false" >取 消</el-button>
                    <el-button type="primary" :loading="loading" size="small" @click="handleUser">确 定</el-button>
                </span>
            </el-dialog>
        </div>
        <div v-if="dialogImport">
            <el-dialog title="导入用户" :visible.sync="dialogImport" width="500px">
                <div class="clearfix">
                    <div class="import-upload">
                        <el-upload
                            ref="importUpload"
                            :action="fileAddr"
                            :headers="headers"
                            :on-success="handleSuccess"
                            :limit="1"
                            :on-exceed="handleExceed"
                            :auto-upload="false"
                            accept=".xlsx"
                        >
                            <el-button class="el-icon-link" size="small" type="primary"> 点击上传</el-button>
                        </el-upload>
                    </div>
                </div>
                <div class="mg-top24 text-align-right">
                    <el-button type="primary" size="small" :loading="loading" @click="submitImport">提 交</el-button>
                </div>
            </el-dialog>
        </div>
    </div>
</template>
<script>
import { getRosterLive, exportRoster, addUser, editUser, delUser, authSetting } from '@/api/live/index'
import { getToken } from '@/utils/auth'
import Pagination from '@/components/Pagination'

export default {
    inject: ['reload'],
    name: 'setupCondition',
    props: ['liveDetail'],
    data() {
        const validateUserid = (rule, value, callback) => {
            if (!value) {
                callback(new Error('用户账号不能为空'))
            } else {
                // eslint-disable-next-line no-useless-escape
                const reg = /^[A-Za-z0-9][A-Za-z0-9\-\_]+$/
                console.log(reg.test(value))
                if (reg.test(value)) {
                    callback()
                } else {
                    return callback(new Error('用户账号只能为字母或数字开头的字母、数字、-、_的组合'))
                }
            }
        }
        return {
            liveId: '',
            conditionForm: {
                auth_type: 'white_list'
            },
            listLoading: false,
            loading: false,
            bLoading: false,
            queryParams: {
                page: 1,
                per_page: 10
            },
            tableData: [],
            pageParams: {
                currentPage: 1,
                pageSize: 10,
                total: 100
            },
            dialogTitle: '',
            userDialog: false,
            userForm: {},
            userRule: {
                user_id: [
                    { required: true, validator: validateUserid, trigger: 'blur' }
                ],
                username: [
                    { required: true, message: '姓名不能为空', trigger: 'blur' }
                ]
            },
            dialogImport: false,
            fileAddr: '',
            headers: {
                authorization: getToken()
            }
        }
    },
    components: {
        Pagination
    },
    created() {
        this.liveId = this.$route.query.id
        this.getRosterLive()
    },
    watch: {
        liveDetail(newVal) {
            this.conditionForm = newVal.auth_setting
        }
    },
    methods: {
        getRosterLive() {
            this.listLoading = true
            this.queryParams.page = this.pageParams.currentPage
            this.queryParams.per_page = this.pageParams.pageSize
            getRosterLive(this.queryParams, this.liveId).then(res => {
                if (res.code === 0) {
                    this.tableData = res.data.list
                    this.pageParams.total = res.data.total
                }
                this.listLoading = false
            }).catch((res) => {
                this.listLoading = false
            })
        },
        openUser(row) {
            this.userId = row ? row.user_id : undefined
            if (this.userId !== undefined) {
                this.dialogTitle = '编辑用户'
                this.userForm = JSON.parse(JSON.stringify(row))
                this.userDialog = true
            } else {
                this.dialogTitle = '新增用户'
                this.userForm = {}
                this.userDialog = true
            }
        },
        handleUser() {
            this.$refs['userForm'].validate((valid) => {
                if (valid) {
                    this.loading = true
                    if (this.userId !== undefined) {
                        editUser(this.userForm, this.liveId, this.userId).then(res => {
                            this.loading = false
                            if (res.code === 0) {
                                this.$message.success(res.msg)
                                this.queryParams.page = 1
                                this.pageParams.currentPage = 1
                                this.getRosterLive()
                                this.userDialog = false
                            }
                        }).catch(res => {
                            this.loading = false
                        })
                    } else {
                        addUser(this.userForm, this.liveId).then(res => {
                            this.loading = false
                            if (res.code === 0) {
                                this.$message.success(res.msg)
                                this.queryParams.page = 1
                                this.pageParams.currentPage = 1
                                this.getRosterLive()
                                this.userDialog = false
                            }
                        }).catch(res => {
                            this.loading = false
                        })
                    }
                }
            })
        },
        delUser(row) {
            this.$confirm('确定删除' + row.username + '吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                delUser(this.liveId, row.user_id).then(res => {
                    if (res.code === 0) {
                        this.$message.success(res.msg)
                        this.reload()
                    }
                })
            })
        },
        preserve() {
            this.bLoading = true
            authSetting(this.conditionForm, this.liveId).then(res => {
                this.bLoading = false
                if (res.code === 0) {
                    this.$message.success(res.msg)
                }
            }).catch(res => {
                this.bLoading = false
            })
        },
        handleSuccess(res) {
            this.loading = false
            if (res.code === 0) {
                this.$message({
                    type: 'success',
                    message: res.msg
                })
                this.reload()
            } else {
                this.$message({
                    type: 'error',
                    message: res.msg
                })
            }
        },
        handleCommand(command) {
            if (command == 'import') {
                this.dialogImport = true
                this.fileAddr = process.env.VUE_APP_BASE_API + '/console/channels/' + this.liveId + '/batch-import-whitelist'
            }
            if (command == 'download') {
                let link = document.createElement('a')
                link.style.display = 'none'
                link.href = 'https://live-oss.busionline.com/assets/template/WhiteListTemplate.xlsx'
                link.setAttribute('download', '白名单模板')
                document.body.appendChild(link)
                link.click()
            }
            if (command == 'export') {
                exportRoster(this.liveId).then(res => {
                    if (res.code === 0) {
                        let link = document.createElement('a')
                        link.style.display = 'none'
                        link.href = res.data.file
                        link.setAttribute('download', res.data.filename)
                        document.body.appendChild(link)
                        link.click()
                    }
                })
            }
        },
        handleExceed() {
            this.$message.warning(`当前限制选择1个文件`)
        },
        submitImport() {
            this.loading = true
            this.$refs.importUpload.submit()
        },
        // 分页
        pageChange(page) {
            this.pageParams.currentPage = page.currentPage
            this.pageParams.pageSize = page.pageSize
            this.getRosterLive()
        },
        search() {
            this.queryParams.page = 1
            this.pageParams.currentPage = 1
            this.getRosterLive()
        }
    }
}
</script>

<style lang="scss" scoped>
@import "@/styles/variables.scss";

.setup-condition-content{
    padding-bottom: 8px;
    .radio-tip{
        font-size: 12px;
        color: #909399;
        line-height: 10px;
    }
}
.userForm-content{
    .el-form-item:last-child{
        margin-bottom: 0;
    }
}
</style>
